import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-child-loading',
  templateUrl: './child-loading.component.html',
  styleUrls: ['./child-loading.component.scss']
})
export class ChildLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
